import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Plane, MapPin, Users, Clock, Shield, Zap, Globe } from 'lucide-react';

const Affretement = () => {
  const serviceCategories = [
    {
      icon: Plane,
      title: 'Avions Privés & Charters',
      services: [
        'Jets privés pour dirigeants',
        'Charters complets pour équipes',
        'Avions cargo pour matériel',
        'Configuration sur mesure'
      ]
    },
    {
      icon: MapPin,
      title: 'Vols en RDC',
      services: [
        'Liaisons régulières Kinshasa-provinces',
        'Transport vers sites miniers',
        'Accès zones reculées',
        'Vols sur demande'
      ]
    },
    {
      icon: Globe,
      title: 'Vols Internationaux',
      services: [
        'Liaisons intercontinentales',
        'Vols Europe-Afrique',
        'Rapatriements',
        'Missions diplomatiques'
      ]
    },
    {
      icon: Users,
      title: 'Transport de Personnel',
      services: [
        'Rotation d\'équipes',
        'Missions de terrain',
        'Délégations corporates',
        'Groupes de travail'
      ]
    },
    {
      icon: Shield,
      title: 'Services Spéciaux',
      services: [
        'Évacuations médicales',
        'Missions d\'urgence 24/7',
        'Sécurité renforcée',
        'Protocoles VIP'
      ]
    },
    {
      icon: Zap,
      title: 'Logistique Aérienne',
      services: [
        'Planification complète',
        'Autorisations de vol',
        'Gestion des escales',
        'Coordination au sol'
      ]
    }
  ];

  const advantages = [
    'Disponibilité 24/7',
    'Flotte diversifiée',
    'Expertise RDC',
    'Réseau international',
    'Sécurité maximale',
    'Flexibilité totale'
  ];

  return (
    <div style={{ background: 'var(--bg-page)' }}>
      {/* Hero Section */}
      <section style={{
        padding: '180px 0 100px',
        background: 'var(--bg-page)',
        borderBottom: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div className="caption" style={{
            color: 'var(--brand-primary)',
            marginBottom: '20px'
          }}>
            Affrètement d'Avions
          </div>
          <h1 className="heading-1" style={{
            color: 'var(--text-primary)',
            marginBottom: '30px',
            maxWidth: '900px'
          }}>
            Solutions d'affrètement aérien en RDC et dans le monde
          </h1>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            maxWidth: '700px',
            marginBottom: '40px'
          }}>
            Avions privés, charters et vols réguliers pour vos équipes et votre matériel.
          </p>
          <Link to="/contact" className="btn-primary">
            Demander un devis <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      {/* Introduction */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{
            maxWidth: '900px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h2 className="heading-3" style={{
              color: 'var(--brand-primary)',
              marginBottom: '30px'
            }}>
              Votre partenaire aérien en République Démocratique du Congo
            </h2>
            <p className="body-medium" style={{
              color: 'var(--text-secondary)',
              marginBottom: '20px'
            }}>
              L'Agence propose des solutions complètes d'affrètement d'avions pour répondre aux besoins spécifiques des entreprises opérant en RDC et à l'international.
            </p>
            <p className="body-medium" style={{
              color: 'var(--text-secondary)'
            }}>
              Que ce soit pour le transport de personnel vers des sites miniers, des missions d'urgence, ou des liaisons régulières entre Kinshasa et les provinces, nous gérons l'intégralité de votre logistique aérienne.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-card)',
        borderTop: '1px solid var(--border-light)',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '60px',
            textAlign: 'center'
          }}>
            Nos solutions d'affrètement
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '40px'
          }}>
            {serviceCategories.map((category, index) => {
              const Icon = category.icon;
              return (
                <div key={index} style={{
                  background: 'var(--bg-page)',
                  padding: '40px',
                  border: '1px solid var(--border-medium)',
                  borderRadius: '8px',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.08)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid var(--brand-primary)',
                    borderRadius: '50%',
                    marginBottom: '20px'
                  }}>
                    <Icon size={28} color="var(--brand-primary)" />
                  </div>
                  <h3 className="heading-4" style={{
                    color: 'var(--text-primary)',
                    marginBottom: '20px',
                    fontSize: '1.1rem'
                  }}>
                    {category.title}
                  </h3>
                  <ul style={{
                    listStyle: 'none',
                    padding: 0
                  }}>
                    {category.services.map((service, idx) => (
                      <li key={idx} style={{
                        marginBottom: '10px',
                        paddingLeft: '20px',
                        position: 'relative',
                        color: 'var(--text-secondary)',
                        fontSize: '0.95rem'
                      }}>
                        <span style={{
                          position: 'absolute',
                          left: 0,
                          color: 'var(--brand-primary)'
                        }}>•</span>
                        {service}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '60px',
            textAlign: 'center'
          }}>
            Pourquoi choisir L'Agence pour vos affrètements ?
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '30px'
          }}>
            {advantages.map((advantage, index) => (
              <div key={index} style={{
                background: 'var(--bg-card)',
                padding: '40px 30px',
                border: '1px solid var(--border-light)',
                borderRadius: '8px',
                textAlign: 'center',
                transition: 'transform 0.3s ease, border-color 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.borderColor = 'var(--brand-primary)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'var(--border-light)';
              }}>
                <div className="heading-4" style={{
                  color: 'var(--brand-primary)',
                  fontSize: '1.1rem'
                }}>
                  {advantage}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Use Cases */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-card)',
        borderTop: '1px solid var(--border-light)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '40px',
            textAlign: 'center'
          }}>
            Cas d'usage typiques
          </h2>

          <div style={{
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            <div style={{
              display: 'grid',
              gap: '30px'
            }}>
              {[
                {
                  title: 'Sociétés Minières',
                  desc: 'Transport régulier du personnel vers les sites de production en province, évacuations médicales d\'urgence'
                },
                {
                  title: 'ONG & Organisations Internationales',
                  desc: 'Missions humanitaires, accès aux zones difficiles, transport de matériel médical'
                },
                {
                  title: 'Grandes Entreprises',
                  desc: 'Rotation d\'équipes, visites de sites, déplacements de dirigeants'
                },
                {
                  title: 'Délégations Gouvernementales',
                  desc: 'Missions officielles, protocoles VIP, sécurité renforcée'
                }
              ].map((useCase, index) => (
                <div key={index} style={{
                  background: 'var(--bg-page)',
                  padding: '30px',
                  border: '1px solid var(--border-light)',
                  borderRadius: '8px',
                  borderLeft: '4px solid var(--brand-primary)'
                }}>
                  <h3 className="heading-4" style={{
                    color: 'var(--text-primary)',
                    marginBottom: '12px',
                    fontSize: '1.1rem'
                  }}>
                    {useCase.title}
                  </h3>
                  <p className="body-small" style={{
                    color: 'var(--text-secondary)'
                  }}>
                    {useCase.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '120px 0',
        background: 'var(--bg-page)',
        borderTop: '1px solid var(--border-light)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px',
          textAlign: 'center'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '30px'
          }}>
            Besoin d'affréter un avion ?
          </h2>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            marginBottom: '40px',
            maxWidth: '600px',
            margin: '0 auto 40px'
          }}>
            Contactez-nous pour discuter de vos besoins spécifiques. Notre équipe est disponible 24/7 pour les urgences.
          </p>
          <div style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link to="/contact" className="btn-primary">
              Demander un devis <ArrowRight size={20} />
            </Link>
            <a href="tel:+243841223949" className="btn-secondary">
              Appeler maintenant
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Affretement;
